import React, {
  useContext, useEffect, useRef, useState,
} from 'react';
import { FormProvider, useForm } from 'react-hook-form';

import { StoreContext, ImportSectionEnum } from 'models/import';
import { CtPlatformBaseItem } from 'models/general';
import FormRadio, { FormRadioItem } from 'components/form/radio';
import ContentBlock, { ContentBlockModifier } from 'components/contentBlock';
import { InfoStepsItem } from 'components/infoSteps';

function ImportPlatformOptionsComponent() {
  const formMethods = useForm({ mode: 'onChange' });
  const ref = useRef<HTMLDivElement>(null);
  const [radioItems, setRadioItems] = useState([] as FormRadioItem[]);

  const {
    baseItems, importType, activeSection, setActiveSection, setImportName,
  } = useContext(StoreContext);

  const mapRadioItems = (opts: CtPlatformBaseItem[]): FormRadioItem[] => opts
    .map((o) => ({ label: o.display_name, value: o.name }));

  const radioControlOptions = {
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
      setImportName({ data: e.target.value });
      setActiveSection({ data: ImportSectionEnum.FORM, ref: undefined });
    },
  };

  useEffect(() => {
    const selectedCardType = (importType && importType.data) || '';

    // console.log('selectedCardType', selectedCardType);
    // console.log('baseItems', baseItems);

    if (selectedCardType && baseItems && baseItems.length) {
      const cardOptions: CtPlatformBaseItem[] = baseItems
        .filter((o: CtPlatformBaseItem) => o.import_type.name === selectedCardType)
        .sort((
          a: CtPlatformBaseItem,
          b: CtPlatformBaseItem,
        ) => a.display_position - b.display_position);

      if (cardOptions && cardOptions.length) {
        const instructionsData: InfoStepsItem[] = cardOptions.map((item) => ({
          title: item.display_name,
          content: item.description || '',
        }));

        setActiveSection({
          data: ImportSectionEnum.OPTIONS,
          ref: ref && ref.current,
          instructions: instructionsData,
        });

        // console.log(cardOptions);

        const items = mapRadioItems(cardOptions);
        if (items) {
          setRadioItems(items);
        }
      }
    }
  }, [importType]); // detect when card is selected

  useEffect(() => {
    if (
      activeSection
      && activeSection.ref
      && activeSection.data === ImportSectionEnum.OPTIONS
    ) {
      formMethods.reset();
    }
  }, [activeSection]); // reset radios if card is clicked

  if (!radioItems) return null;

  return (
    <div ref={ref}>
      <ContentBlock
        title="Choose the type of import"
        desc="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."
        modifiers={[ContentBlockModifier.MAIN]}
      >
        <FormProvider {...formMethods}>
          <form className="ct_form">
            {radioItems && (
              <FormRadio name="radioControl" options={radioControlOptions} items={radioItems} />
            )}
          </form>
        </FormProvider>
      </ContentBlock>
    </div>
  );
}

export default ImportPlatformOptionsComponent;
